module.exports = __webpack_public_path__ + "media/images/home/logo-clutter-endorser-black-0faf2cd92d0662a809f9c06872a3b79d.png";